import Vue from 'vue';
import Router from 'vue-router';
// import Home from '@/components/Home';
import NewsHome from '@/components/NewsHome';

import UploadVideo from '@/components/UploadVideo';
import NewsInDetail from "@/components/NewsInDetail";
Vue.use(Router);
const router = new Router({
  routes: [

    {
      path: '/',
      name: 'NewsHome',
      component: NewsHome,
    },

    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home,
    // },

    {
      path:'/upload-video',
      name:'UploadVideo',
      component: UploadVideo,
    },

    {
      path: '/news-detail',
      name: "NewsInDetail",
      component: NewsInDetail
    }
  ],
});
export default router;
